import React from 'react';
import './About.css';
import photo from './profile2.jpg';
import Pulse from 'react-reveal/Pulse';
const About = () => {
   return (
      <div className='main'>
      <Pulse>
       <div className='container'>
       <div className='row about'>
       <div className='col-md-6 col-sm-12 py-5'>
         <div className='text-center'>
         <img src={photo} alt=""  className='profile' />
         </div>
         <h2>About Me </h2>
         <div className='text'>
         <h5>I am a MERN-Stack WEB Developer. I am working with React, Node.js and MongoDB. I also have experience in developing static websites using HTML5, CSS3 and JavaScript (ES6). I am a quick learner. I believe in hard work and efficiency. That's why I am always ready to accomplish any task by working hard. I always focus on learning new technology. My goal is to become A World-Class Professional Web Developer.</h5>
         </div>
       </div>
       <div className='col-md-6 col-sm-12'>
       <div style={{marginTop:'15%'}}>
            <div>
   
            <h4>My Skill Sets</h4>
            <hr style={{color:'salmon',width:'150px'}}/>
            </div>
            <div className='d-flex flex-wrap'>
            <div className="tech">Java Script</div>
            <div className="tech">ES6</div>
            <div className="tech">React.js</div>
            <div className="tech">Node.js</div>
            <div className="tech">Express.js</div>
            <div className="tech">Mongodb</div>
            <div className="tech">AWS</div>
            <div className="tech">Html,Css</div>
            <div className="tech">React-bootstrap</div>
            <div className="tech">Redux</div>
            <div className="tech">Git</div>
            <div className="tech">Heroku</div>
            <div className="tech">Linux</div>
            <div className="tech">Firebase</div>
            <div className="tech">Mysql</div>
            <div className="tech">Core Java</div>
            <div className="tech">C</div>
            
            </div>
            
            <div>
            <h4>I would love to work with</h4>
            <hr style={{color:'salmon',width:'290px'}}/>
            <div className='d-flex flex-wrap'>
            <div className="tech">Java Script</div>
            <div className="tech">ES6</div>
            <div className="tech">React.js</div>
            <div className="tech">Node.js</div>
            <div className="tech">Express.js</div>
            <div className="tech">Mongodb</div>
            <div className="tech">AWS</div>
            <div className="tech">Redux</div>
            <div className="tech">Git</div>
            <div className="tech">Heroku</div>
            <div className="tech">Linux</div>
            <div className="tech">Devops</div>   
            </div>  
            </div>

            <div>
            <h4>I prefer not to work with</h4>
            <hr style={{color:'salmon',width:'290px'}}/>
            <div className='d-flex flex-wrap'>
            <div className="tech">Php</div>
            <div className="tech">Wordpress</div>
            <div className="tech">C sharp</div>
            <div className="tech">Jquery</div>
            <div className="tech">Laravel</div>  
            </div>
            </div>
            
            </div>
            
       </div>
       </div>
       </div>
       </Pulse>
      </div>
   );
};

export default About;